const gradientClass =
  'bg-gradient-to-r from-[#D4AF37] via-[#FFFFFF] to-[#D4AF37] bg-clip-text text-transparent'

export function LogoText({ className = '' }: { className?: string }) {
  return (
    <h1
      className={`text-6xl h-20 lg:h-30 font-bold mb-6 ${gradientClass} ${className}`.trim()}
    >
      BINYUMA
      <sup
        className={`text-3xl ${gradientClass}`}
        style={{ position: 'relative', top: '-21px', left: '-4px' }}
      >
        TV
      </sup>
    </h1>
  )
}
